import { render, staticRenderFns } from "./_base-customer-address.vue?vue&type=template&id=7a61d877&"
import script from "./_base-customer-address.vue?vue&type=script&lang=js&"
export * from "./_base-customer-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports